module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.8e9578cc.woff2";